import React from 'react';
import { useHistory } from "react-router-dom";
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { 
    ExternalLink, 
    Code2, 
    Rss,
    MoreVertical,
    Edit3,
    Power,
    PowerOff,
    Trash2
} from 'lucide-react';
import { Card } from '../ui/bootstrap';

const PodcastItem = ({ 
    item, 
    index, 
    org_id, 
    id, 
    integration,
    setShow,
    setSelectedShow,
    setShowEmbedCodeModal,
    setShowConfirmation,
    publishChannel,
    unpublishChannel
}) => {
    const history = useHistory();

    const MenuToggle = React.forwardRef(({ onClick }, ref) => (
        <button
            type="button"
            className="btn"
            style={{ padding: '7px 10px', background: 'rgba(var(--bs-primary-rgb), 0.06)', border: '1px solid rgba(var(--bs-primary-rgb), 0.12)', borderRadius: 8, color: 'var(--bs-primary)' }}
            ref={ref}
            onClick={(e) => { e.preventDefault(); onClick(e); }}
        >
            <MoreVertical size={16} />
        </button>
    ));

    const actionBtnStyle = {
        background: 'rgba(var(--bs-primary-rgb), 0.06)',
        border: '1px solid rgba(var(--bs-primary-rgb), 0.12)',
        borderRadius: 8,
        padding: '7px 10px',
        color: 'var(--bs-primary)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.15s ease',
    };

    const badgeBase = { borderRadius: 50, fontSize: 11, padding: '3px 10px', fontWeight: 500, border: 'none' };

    return (
        <Card
            className="rounded-4 p-4"
            style={{
                boxShadow: '0 2px 16px rgba(0,0,0,0.05)',
                transition: 'box-shadow 0.2s ease',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 6px 24px rgba(var(--bs-primary-rgb), 0.1)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 2px 16px rgba(0,0,0,0.05)'; }}
        >
            <div className="d-flex align-items-start gap-4">
                {/* Poster */}
                <img
                    alt={item.title}
                    src={item.poster_path}
                    width={80}
                    height={80}
                    onClick={() => history.push(`/organisation/${org_id}/integration/${id}/podcast/${item.id}/episodes`, { showDetails: item })}
                    className="flex-shrink-0 rounded-3"
                    style={{ objectFit: 'cover', cursor: 'pointer' }}
                />

                {/* Content */}
                <div className="flex-grow-1 min-width-0">
                    <h5
                    className="fw-semibold mb-1 text-body-emphasis"
                    style={{ fontSize: '1rem', cursor: 'pointer' }}
                        onClick={() => history.push(`/organisation/${org_id}/integration/${id}/podcast/${item.id}/episodes`, { showDetails: item })}
                    >
                        {item.title}
                    </h5>
                    <p className="text-muted mb-2" style={{
                        fontSize: '0.83rem', lineHeight: 1.55,
                        display: '-webkit-box', WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical', overflow: 'hidden',
                    }}>
                        {item.body}
                    </p>
                    <div className="d-flex align-items-center gap-3">
                        <span style={{ ...badgeBase, background: item.is_published ? 'rgba(67,233,123,0.15)' : 'rgba(108,117,125,0.1)', color: item.is_published ? 'var(--bs-success)' : 'var(--bs-secondary)' }}>
                            {item.is_published ? 'Published' : 'Unpublished'}
                        </span>
                        <span className="text-muted" style={{ fontSize: 12 }}>
                            {item.is_automatic && integration ? integration.content_count : item.episode_count} Episodes
                        </span>
                    </div>
                </div>

                {/* Actions */}
                <div className="d-flex align-items-center gap-1 flex-shrink-0">
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>View Page</Tooltip>}>
                        <a href={`${process.env.REACT_APP_PODCAST_LANDING_PAGE_BASE_URL}/${org_id}/${id}/${item.id}`} target="_blank" rel="noreferrer noopener" className="btn" style={actionBtnStyle}>
                            <ExternalLink size={16} />
                        </a>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Embed Code</Tooltip>}>
                        <button type="button" className="btn" style={actionBtnStyle} onClick={() => { setSelectedShow(item); setShow(true); }}>
                            <Code2 size={16} />
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>RSS Feed</Tooltip>}>
                        <button type="button" className="btn" style={actionBtnStyle} onClick={() => { setSelectedShow(item); setShowEmbedCodeModal(true); }}>
                            <Rss size={16} />
                        </button>
                    </OverlayTrigger>
                    <Dropdown as="span">
                        <Dropdown.Toggle as={MenuToggle} />
                        <Dropdown.Menu>
                            <Dropdown.Item as="div" onClick={() => history.push(`/organisation/${org_id}/integration/${id}/podcast/${item.id}`)}>
                                <Edit3 size={13} className="me-2" />Edit Settings
                            </Dropdown.Item>
                            {item.is_published ? (
                                <Dropdown.Item as="div" onClick={() => unpublishChannel()}>
                                    <PowerOff size={13} className="me-2" />Unpublish Show
                                </Dropdown.Item>
                            ) : (
                                <Dropdown.Item as="div" onClick={() => publishChannel()}>
                                    <Power size={13} className="me-2" />Publish Show
                                </Dropdown.Item>
                            )}
                            <Dropdown.Item as="div" className="text-danger" onClick={() => { setSelectedShow(item); setShowConfirmation(true); }}>
                                <Trash2 size={13} className="me-2" />Delete
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </Card>
    );
};

export default PodcastItem;


